import type { LayerPopupConfiguration } from './model';
import { formatScalarTitle, formatScalarValue } from '../shared/scalarPresentation';

export interface PopupPresentationRow {
  readonly field: string;
  readonly label: string;
  readonly value: string;
}

export interface PopupPresentation {
  readonly title: string | null;
  readonly rows: readonly PopupPresentationRow[];
}

export const formatPopupValue = formatScalarValue;

export function createPopupPresentation(
  configuration: LayerPopupConfiguration,
  properties: Readonly<Record<string, unknown>> | null,
): PopupPresentation | null {
  if (!configuration.enabled) return null;
  const title = configuration.titleField
    ? formatScalarTitle(properties?.[configuration.titleField])
    : null;
  const rows = configuration.fields
    .filter((field) => field.visible)
    .map((field) => ({
      field: field.field,
      label: field.label,
      value: formatPopupValue(properties?.[field.field]),
    }));
  return title === null && rows.length === 0 ? null : { title, rows };
}
